/* Product page, sold out sizes (SimGym 2026-10-01):
   1. every sold out size button gets a small "Sold out" tag (rb-product.js already strikes it through),
   2. inside each size group (area rugs / runners / round ...) the sizes in stock come first, sold out after,
      each part keeping its small to large order (buttons are matched by their value, so variant logic is untouched),
   3. when a sold out size is chosen, "Similar rugs in stock in this size" lists up to 4 other rugs that have that
      exact size in stock: Shopify's related products first, then the all rugs collection, ranked by shared
      style and colour tags. Prices come from each rug's own /products/<handle>.js so they are in the shopper's currency.
   Single option products only (the size is the only option), like the rest of the size logic. */
(function () {
  const root = document.querySelector('[data-rb-product]'); if (!root) return;
  const dataEl = document.getElementById('rbProductData'); if (!dataEl) return;
  const data = JSON.parse(dataEl.textContent);

  // PreOrder Globo's "Email me when available" button: show it only while the chosen size is sold out. Globo leaves it
  // on screen after the shopper switches back to an in-stock size, and its form is disabled for in-stock sizes, so the
  // email could not be typed. Runs for every product, before the size-only logic below.
  (() => {
    const vidEl = document.getElementById('rbVariantId');
    const cur = () => data.variants.find((x) => String(x.id) === String(vidEl && vidEl.value));
    const sync = () => {
      const v = cur(); const show = !!(v && !v.available);
      document.querySelectorAll('.gBackInStock-Button').forEach((el) => { if (el.hidden === show) el.hidden = !show; });
    };
    if (vidEl) vidEl.addEventListener('change', () => setTimeout(sync, 0));
    root.addEventListener('click', (e) => { if (e.target.closest('[data-option] .size')) setTimeout(sync, 0); });
    new MutationObserver(() => sync()).observe(root, { childList: true, subtree: true });
    sync();
  })();
  const groups = [...root.querySelectorAll('[data-option]')];
  if (groups.length !== 1 || !groups[0].hasAttribute('data-size-option')) return;
  const g = groups[0];
  const C = (() => { try { return JSON.parse(document.getElementById('rbStockText').textContent); } catch (e) { return {}; } })();
  const T = (window.RBCFG && window.RBCFG.t) || {};
  const soldOut = T.sold_out || 'Sold out';
  const R = (window.RBCFG && window.RBCFG.routes) || {};
  const base = (R.root || '/').replace(/\/?$/, '/');
  const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const norm = (s) => String(s || '').toLowerCase().replace(/[′’]/g, "'").replace(/[″”]/g, '"').replace(/×/g, 'x').replace(/\s+/g, '');
  const variantOf = (val) => data.variants.find((v) => v.options[0] === val);
  const inStock = (b) => { const v = variantOf(b.dataset.value); return !!(v && v.available); };

  // 1 + 2: tag and reorder (runs after rb-product.js has sorted and grouped the buttons)
  function arrange() {
    const kids = [...g.children];
    const segments = []; let cur = [];
    kids.forEach((k) => {
      if (k.classList.contains('size-group')) { if (cur.length) segments.push(cur); segments.push([k]); cur = []; }
      else if (k.classList.contains('size')) cur.push(k);
    });
    if (cur.length) segments.push(cur);
    segments.forEach((seg) => {
      if (seg[0].classList.contains('size-group')) { g.appendChild(seg[0]); return; }
      seg.filter(inStock).concat(seg.filter((b) => !inStock(b))).forEach((b) => g.appendChild(b));
    });
    g.querySelectorAll('.size').forEach((b) => {
      const out = !inStock(b);
      let tag = b.querySelector('.size-so');
      if (out && !tag) { tag = document.createElement('span'); tag.className = 'size-so'; tag.setAttribute('aria-hidden', 'true'); tag.textContent = soldOut; b.appendChild(tag); }
      if (!out && tag) tag.remove();
      const label = String(b.dataset.value).replace(/'/g, '′');
      b.setAttribute('aria-label', out ? `${label}, ${soldOut}` : label);
    });
    g.classList.toggle('has-so', !!g.querySelector('.size-so'));
  }

  // 3: similar rugs in stock in the chosen size
  const box = document.createElement('section');
  box.className = 'rb-similar'; box.hidden = true; box.setAttribute('aria-live', 'polite');
  // right under the size picker, so it sits next to the sold out size the shopper just chose
  (g.closest('.rb-option') || g).after(box);
  let me = null, allRugs = {}, token = 0;
  const getJSON = (u) => fetch(u, { headers: { Accept: 'application/json' } }).then((r) => (r.ok ? r.json() : null)).catch(() => null);
  const priceOf = (p, size) => { const v = (p.variants || []).find((x) => norm(x.option1 || (x.options && x.options[0])) === norm(size) && x.available); return v; };

  async function similar(size) {
    const my = ++token;
    if (!me) me = await getJSON(`${base}products/${encodeURIComponent(data.handle)}.js`);
    if (!me || my !== token) return;
    const isPad = (p) => /(^|-)[hm]pad(-|$)/i.test(p.handle) || /pad/i.test(p.product_type || p.type || '');
    const pool = new Map();
    const take = (list) => (list || []).forEach((p) => { if (p && p.handle !== data.handle && !isPad(p) && !pool.has(p.handle) && priceOf(p, size)) pool.set(p.handle, p); });
    /* MATCH-START: which rugs count as similar (Waise 2026-10-01, stricter rule). Pure: no page access, so it can be
       tested on its own.
       1. Kids and playroom rugs match only kids rugs, and other rugs only other rugs (from the title).
       2. Style comes from the title words only (tags like "Modern" are on almost every rug).
       3. The suggested rug's main colour (the first colour word in its title) must be one of this rug's colours.
       Rugs that also share a style come first, then the rest; ties go to the closest price.
       Fewer than 2 qualifying rugs: the block stays hidden (handled by the caller). */
    const COLOURS = { beige: ['beige', 'cream', 'ivory'], white: ['white'], grey: ['grey', 'gray', 'silver'], blue: ['blue', 'navy', 'teal'], red: ['red', 'burgundy'],
      brown: ['brown', 'taupe'], black: ['black', 'charcoal'], green: ['green', 'olive', 'sage'], multi: ['multi', 'multicolor', 'multicolour', 'rainbow'],
      yellow: ['yellow', 'gold', 'mustard'], pink: ['pink', 'blush'], orange: ['orange', 'rust', 'terracotta'], purple: ['purple', 'lilac', 'lavender', 'plum'] };
    const STYLES = { modern: ['modern', 'abstract', 'minimalist', 'scandinavian', 'mid-century'], geometric: ['geometric', 'trellis', 'checkered', 'diamond', 'chevron'],
      striped: ['striped', 'stripe', 'linear'], traditional: ['traditional', 'persian', 'oriental', 'medallion', 'vintage', 'damask'], bohemian: ['bohemian', 'boho', 'moroccan', 'kilim', 'tribal', 'southwestern'],
      farmhouse: ['farmhouse', 'rustic', 'coastal'], floral: ['floral', 'botanical', 'leaf'], shaggy: ['shag', 'shaggy', 'plush'], distressed: ['distressed', 'ombre'],
      contemporary: ['contemporary', 'transitional'] };
    const KIDS = ['kids', 'kid', 'playroom', 'nursery', 'children', 'baby', 'education', 'educational', 'learning'];
    const wordsOf = (t) => String(t || '').toLowerCase().split(/[^a-z-]+/).filter(Boolean);
    const famOf = (map, w) => Object.keys(map).find((k) => map[k].includes(w));
    const famsIn = (map, words) => new Set(words.map((w) => famOf(map, w)).filter(Boolean));
    const isKids = (p) => wordsOf(p.title).some((w) => KIDS.includes(w));
    const coloursOf = (p) => { const t = famsIn(COLOURS, wordsOf(p.title)); return t.size ? t : famsIn(COLOURS, wordsOf((p.tags || []).filter((x) => !/\d/.test(x)).join(' '))); };
    const mainColour = (p) => { for (const w of wordsOf(p.title)) { const f = famOf(COLOURS, w); if (f) return f; } return null; };
    const stylesOf = (p) => famsIn(STYLES, wordsOf(p.title));
    const centsOf = (v) => (v ? (String(v.price).includes('.') ? Math.round(parseFloat(v.price) * 100) : Number(v.price)) : 0);
    const matchSimilar = (me, list, size, priceOf, norm) => {
      const myC = coloursOf(me), myS = stylesOf(me), myKids = isKids(me);
      const myPrice = ((me.variants || []).find((x) => norm(x.option1) === norm(size)) || {}).price || me.price || 0;
      return list.map((p, i) => {
        if (isKids(p) !== myKids) return null;
        const mc = mainColour(p);
        if (!mc || !myC.has(mc)) return null;
        const st = [...stylesOf(p)].filter((k) => myS.has(k)).length;
        const pr = centsOf(priceOf(p, size));
        return { p, tier: st ? 0 : 1, st, close: myPrice ? Math.abs(pr - myPrice) / myPrice : 1, i };
      }).filter(Boolean).sort((a, b) => a.tier - b.tier || b.st - a.st || a.close - b.close || a.i - b.i);
    };
    /* MATCH-END */
    const qualified = () => matchSimilar(me, [...pool.values()], size, priceOf, norm);
    const rec = await getJSON(`${base}recommendations/products.json?product_id=${me.id}&limit=10&intent=related`);
    take(rec && rec.products);
    for (let page = 1; page <= 3; page++) {
      if (page > 1 && qualified().filter((x) => x.tier === 0).length >= 4) break;
      if (!allRugs[page]) { const j = await getJSON(`${base}collections/all-rugs/products.json?limit=250&page=${page}`); allRugs[page] = (j && j.products) || []; }
      take(allRugs[page]);
      if (allRugs[page].length < 250) break;
    }
    if (my !== token) return;
    const ranked = qualified();
    if (ranked.length < 2) { box.hidden = true; return; }
    const picks = ranked.slice(0, 4).map((x) => x.p);
    if (!picks.length) { box.hidden = true; return; }
    // the rug's own .js has prices in the shopper's currency
    const full = await Promise.all(picks.map((p) => getJSON(`${base}products/${encodeURIComponent(p.handle)}.js`)));
    if (my !== token) return;
    const cards = full.map((p) => {
      if (!p) return '';
      const v = priceOf(p, size); if (!v) return '';
      const img = (v.featured_image && v.featured_image.src) || p.featured_image || (p.images && p.images[0]) || '';
      const src = img ? (img.startsWith('//') ? 'https:' + img : img) : '';
      const sized = (w) => src + (src.includes('?') ? '&' : '?') + 'width=' + w;
      const fmt = (c) => (window.RBUI ? window.RBUI.money(c) : '$' + (c / 100).toFixed(2));
      // like the product page: a marked down size shows its own compare at price; a full price size carries
      // data-rbev-min so rb-events.js paints the sale price during an event (and the single price again after it)
      const marked = v.compare_at_price && v.compare_at_price > v.price;
      const priceHTML = marked ? `<s>${esc(fmt(v.compare_at_price))}</s> <span class="now is-sale">${esc(fmt(v.price))}</span>` : `<span class="now">${esc(fmt(v.price))}</span>`;
      const evAttr = marked ? '' : ` data-rbev-min="${Number(v.price)}"`;
      const full = String(p.title).replace(/ (Indoor )?(Area )?Rug.*$/i, '').trim();
      const name = full.split(' ')[0], rest = full.split(' ').slice(1).join(' ');
      return `<a class="rb-sim-card" href="${esc(p.url + '?variant=' + v.id)}">
        <span class="rb-sim-img">${src ? `<img src="${esc(sized(240))}" srcset="${esc(sized(240))} 240w, ${esc(sized(400))} 400w" sizes="(max-width: 640px) 40vw, 160px" alt="" loading="lazy" width="240" height="300">` : ''}</span>
        <span class="rb-sim-name">${esc(name)}</span>${rest ? `<span class="rb-sim-sub">${esc(rest)}</span>` : ''}
        <span class="rb-sim-price num"${evAttr}>${priceHTML}</span></a>`;
    }).filter(Boolean);
    if (cards.length < 2) { box.hidden = true; return; }
    box.innerHTML = `<h2 class="rb-sim-title">${esc(C.similar || 'Similar rugs in stock in this size')} <span class="num">${esc(String(size).replace(/'/g, '′'))}</span></h2><div class="rb-sim-list">${cards.join('')}</div>`;
    box.hidden = false;
  }

  function onChange() {
    const vid = document.getElementById('rbVariantId');
    const v = data.variants.find((x) => String(x.id) === String(vid && vid.value)) || null;
    if (v && !v.available) similar(v.options[0]);
    else { token++; box.hidden = true; }
  }

  const start = () => {
    arrange();
    const vid = document.getElementById('rbVariantId');
    if (vid) vid.addEventListener('change', onChange);
    g.addEventListener('click', () => setTimeout(onChange, 0));
    onChange();
  };
  start();
})();
